import { useLogProductPageOpenedEvent } from 'api/services/LogEventService';
import { ProductTypes } from 'api/types/ReferenceData';
import { Spinner } from 'components/common/Spinner/Spinner';
import { WHITELABEL_EVENT_KEY } from 'components/constants/Constants';
import { useProductPageModel } from 'components/pages/product/ProductPageModel';
import { UXBProductPage } from 'components/pages/product/variants/UXB/UXBProductPage';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';
import { EventProduct } from 'types/Products';
import { envs } from '../../../../envs';

const ProductPage = () => {
  const [product, setProduct] = useState<EventProduct | undefined>();
  const { getProduct } = useProductPageModel();
  const { isLoading } = useAuth();
  const { productKey } = useParams();
  const logProductPageOpenedEvent = useLogProductPageOpenedEvent();
  useEffect(() => {
    !isLoading &&
      productKey &&
      getProduct(WHITELABEL_EVENT_KEY, productKey, setProduct);
  }, [productKey, isLoading, getProduct]);

  useEffect(() => {
    logProductPageOpenedEvent(
      product?.old_key,
      product?.name,
      product?.segment,
      product?.company?.key,
      product?.type
    );
  }, [
    logProductPageOpenedEvent,
    product?.company?.key,
    product?.name,
    product?.old_key,
    product?.segment,
    product?.type
  ]);

  return product ? (
    <>
      <Helmet>
        <meta name="description" content={product.marketing?.description} />
        <title>
          {product.name}
          {product.company?.name ? ` by ${product.company.name}` : ''}
        </title>
        <link
          rel="canonical"
          href={`${envs.REACT_APP_COVALO_FRONTOFFICE}/${ProductTypes.find(
            el => el.value === product.type
          )?.label.toLowerCase()}/permalink/${product.id}`}
        />
      </Helmet>
      <UXBProductPage product={product as EventProduct} />
    </>
  ) : (
    <Spinner />
  );
};

export default ProductPage;
